import { Observable } from 'rxjs';

export class MessageHandler {
	me: HTMLElement;
	buttonContainer: HTMLElement = null;

	constructor(private title: string = '', private body: string = '') {
		this.baseHtml();
	}

	asError() {
		this.me.classList.add('error');
		return this;
	}

	asWarning() {
		this.me.classList.add('warning');
		return this;
	}

	addClass(cls: string) {
		this.me.classList.add(cls);
		return this;
	}

	confirm(confirmBtn: string, cancelBtn: string): Observable<any> {
		let btnOk = this.addButton('span4 offset1', confirmBtn);
		let btnAbort = this.addButton('span4', cancelBtn);

		this.addClass('confirm');
		this.finalize();

		return Observable.create(observer => {
			btnOk.addEventListener('click', () => {
				observer.next({ el: this.me });
				this.destroy();
			});
			btnAbort.addEventListener('click', () => {
				observer.error({ el: this.me });
				this.destroy();
			});
		});
	}

	inform(buttonText: string): Observable<any> {
		let btnOk = this.addButton('', buttonText);

		this.addClass('inform');
		this.finalize();

		return Observable.create(observer => {
			btnOk.addEventListener('click', () => {
				observer.next({ el: this.me });
				this.destroy();
			});
		});
	}

	persistant(): HTMLElement {
		this.finalize();

		return this.me;
	}

	/** PRIVATE **/

	private baseHtml() {
		this.me = document.createElement('div');
		this.me.className = 'visibaMessageWrap';
		this.me.innerHTML = `<div class="visibaMessage">
                                <div class="inner">
                                    <h2>${this.title}</h2>
                                    <div class="text">${this.body}</div>
                                </div>
                            </div>`;
	}

	private addButton(cls: string, text: string): HTMLElement {
		if (this.buttonContainer === null) {
			this.buttonContainer = document.createElement('div');
			this.buttonContainer.className = 'buttons';
			this.me.querySelector('.inner').appendChild(this.buttonContainer);
		}

		let btn = document.createElement('div');
		btn.className = `btn ${cls}`;
		btn.innerText = text;
		this.buttonContainer.appendChild(btn);
		return btn;
	}

	private addCloseButton(text: string): HTMLElement {
		let btn = document.createElement('a');
		btn.className = 'close';
		btn.innerText = text;
		this.me.querySelector('.inner').appendChild(btn);
		return btn;
	}

	private finalize() {
		document.querySelector('body').appendChild(this.me);
		this.setTopPosition();

		document.addEventListener('scroll', this.setTopPosition);
	}

	destroy() {
		this.me.parentElement.removeChild(this.me);
		document.removeEventListener('scroll', this.setTopPosition);
		this.me = null;
	}

	private setTopPosition() {
		let topMarg = 0;
		if (
			document.querySelector('office-header') !== null &&
			window.pageYOffset < document.querySelector('office-header header').clientHeight + 20
		)
			topMarg = document.querySelector('office-header header').clientHeight - window.pageYOffset + 20;

		if (document.querySelector('licenceholder-header') !== null)
			topMarg = document.querySelector('licenceholder-header header').clientHeight;

		topMarg = Math.max(topMarg - window.pageYOffset, 0);

		(document.querySelector('.visibaMessageWrap .visibaMessage') as HTMLElement).style.top = topMarg + 'px';
	}
}
